import {urlForSpace} from "@src/utils/endpoints-urls";


export function urlForRouteTimedShuttles(spaceId: string): string {
	return `${urlForSpace(spaceId)}/route-timed-shuttle`;
}

export function urlForRouteTimedShuttlesStops(spaceId: string): string {
    return `${urlForRouteTimedShuttles(spaceId)}/stops`;
}